import { FC } from 'react';

import imgSvg from 'assets/images/cancel-transfer.svg';
import Button from 'components/_core/Button';
import Modal from 'components/_core/Modal';
import useToast from 'components/ToastProvider/useToast';
import getErrorMessage from 'features/Bento/libs/errors/getErrorMessage';

import useCancelBankTransfer from './hooks/cancelBankTransfer';
import locales from './locales';

interface CancelTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
  transactionId: string;
}

const CancelTransferModal: FC<CancelTransferModalProps> = ({
  isOpen,
  onClose,
  transactionId,
}) => {
  const [cancelBankTransfer, { loading: cancelBankTransferLoading }] =
    useCancelBankTransfer(transactionId);
  const { showToast } = useToast();

  const onConfirm = async () => {
    try {
      await cancelBankTransfer();
      onClose();
      showToast({ message: locales.cancelTransferSucceed, type: 'success' });
    } catch (error) {
      onClose();
      showToast({ message: getErrorMessage(error as Error), type: 'error' });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header />
      <Modal.Body>
        <Modal.Image src={imgSvg} />
        <Modal.Title>{locales.title}</Modal.Title>
        <Modal.Description>{locales.description}</Modal.Description>
      </Modal.Body>
      <Modal.Footer>
        <Button marginRight="auto" onClick={onClose} variant="inline-primary">
          {locales.cancel}
        </Button>
        <Button
          icon="arrow-right"
          isLoading={cancelBankTransferLoading}
          onClick={onConfirm}
        >
          {locales.confirm}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelTransferModal;
